export default __webpack_public_path__ + "static/media/ww1.ffc211fc.jpg";